import * as React from "react";
import { Dialog } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import placeholderCard from "../../images/ui/placeholder-card.png";

export const FullSizeCardModal = ({ card, onClose, open }) => {
    const useStyles = makeStyles((theme) => ({
        paper: {
            margin: 0,
        },
        image: {
            maxHeight: `calc(100vh - 64px)`,
        },
    }));
    const classes = useStyles();
    const fullSizeImage = card.image_url
        ? card.image_url
        : card.image
        ? `${process.env.GATSBY_API_URL}${card.image.data.asset_url}`
        : placeholderCard;
    const fullTitle = card.subtitle
        ? `${card.name} - ${card.subtitle}`
        : card.name;

    return (
        <Dialog
            classes={{ paper: classes.paper }}
            onClick={onClose}
            onClose={onClose}
            open={open}
        >
            <img
                alt={fullTitle}
                className={classes.image}
                src={fullSizeImage}
                title={fullTitle}
            />
        </Dialog>
    );
};
